<div class="sidebar-container">
  <div class="app-name">
    <p class="name-size">SyncHPC</p>
    <p class="name-size">Access</p>
  </div>
  <div class="entity-container">
    <app-client-entities></app-client-entities>
  </div>
  <div class="sidebar-footer">
    <div class="logout-container">
      <button (click)="logOut()" class="signoutBtn btn btn-outline-secondary">
        <span aria-hidden="true"
              class="bi bi-box-arrow-right button-icon-span">
        </span>
        Log Out
      </button>
      <button (click)="logOut()" class="signoutBtn-sm btn btn-outline-secondary">
        <span aria-hidden="true"
              class="bi bi-box-arrow-right button-icon-span-sm">
        </span>
      </button>
    </div>
    <div>
      <p>2023.8.1615</p>
    </div>
  </div>
</div>
